<template>
  <li class="has-sub">
    <a href="javascript:;">
      <b class="caret pull-right"></b>
      <i class="fa fa-book"></i>
      <span>Kodifikasi</span>
    </a>
    <ul class="sub-menu">
      <li><router-link to="/topic-management"><a>Pengaturan Bab</a></router-link></li>
      <li><router-link to="/topic-mapping">Mapping</router-link></li>
    </ul>
  </li>
</template>
<script>
export default {
  name: 'navigation-nav'
}
</script>




// WEBPACK FOOTER //
// Navigation.vue?34d8bd50